import React, {useMemo} from "react";
import {BannerFirm} from "../../Modules/BannerFirm/BannerFirm";
import {Post} from "../../Modules/Post/Post";
import Posts from "../../Data/Post/Posts";
import {Review} from "../../Modules/Review/Review";
import Reviews from "../../Data/Reviews/Reviews";
import BannerFirms from "../../Data/BannerFirm/FirmBanner";
import HeroSlider from "../../Modules/HeroSlider/HeroSlider";
import ProductsSlider from "../../Modules/ProductsSlider/ProductsSlider";
import items from "../../Data/Items/Items";
import PromoBanner from "../../Modules/PromoBanner/PromoBanner";

const HomePage:React.FC = () => {

    const laptopItems = useMemo(() => {
        return items.filter(item => item.subcategory === 'laptop');
    }, []);

    const desktopItems = useMemo(() => {
        return items.filter(item => item.subcategory === 'desktop');
    }, []);

    const saleItems = useMemo(() => {
        return items.filter(item => item.sale != null);
    }, []);

        return (
        <main>
            <div className={"container"}>
                <HeroSlider/>

                <ProductsSlider
                    title={'New Products'}
                    items={items}
                />

                <ProductsSlider
                    title="Laptop"
                    items={laptopItems}
                />

                <ProductsSlider
                    title="Destop"
                    items={desktopItems}
                />

                <ProductsSlider
                    title="Sale"
                    items={saleItems}
                />

                <PromoBanner/>

                <BannerFirm className={'pt-7 max-sm:pt-1'} banners={BannerFirms} classNameImg={'max-w-32 max-lg:max-w-20 max-sm:max-w-16'}/>

                <Post title={'Follow us on Instagram for News, Offers & More'} className={'pt-11'} posts={Posts}/>

                <Review reviews={Reviews} button={'Leave Us A Review'} className={'pt-14'}/>
            </div>
        </main>
    )
}

export default HomePage